export { DAYS_IN_YEAR };

const DAYS_IN_YEAR = 365;
